import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetTasksDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetTasksDossierByIdController.php
* @route '/api/dossier/{dossier}/tasks'
*/
const GetTasksDossierByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTasksDossierByIdController.url(args, options),
    method: 'get',
})

GetTasksDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/tasks',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetTasksDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetTasksDossierByIdController.php
* @route '/api/dossier/{dossier}/tasks'
*/
GetTasksDossierByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetTasksDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetTasksDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetTasksDossierByIdController.php
* @route '/api/dossier/{dossier}/tasks'
*/
GetTasksDossierByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTasksDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetTasksDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetTasksDossierByIdController.php
* @route '/api/dossier/{dossier}/tasks'
*/
GetTasksDossierByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTasksDossierByIdController.url(args, options),
    method: 'head',
})

export default GetTasksDossierByIdController